import {
  BlackBanner,
  ExploreFundSection,
  FaqSection,
  FundHousesSection,
  GrowthSection,
  LearnMutualFund,
  QuickReads,
  StickyHeader,
  // TestimonialsSection,
  TopFundsSection,
  TopPlansSection,
  NFOSection,
  UsefullToolsSection,
} from '../components/homePageNew';
import WhyCleartaxNew from '../components/plan/whyCleartaxNew';
import { Heading } from '../components/common/heading';

export const SECTION_TOP_FUNDS = {
  filters: [
    {
      title: 'Equity',
      fundType: 'Equity',
    },
    {
      title: 'Mid cap funds',
      fundType: 'Equity',
      categoryFilterValue: 'Mid Cap',
    },
    {
      title: 'Large cap funds',
      fundType: 'Equity',
      categoryFilterValue: 'Large Cap',
    },
    {
      title: 'Small cap funds',
      fundType: 'Equity',
      categoryFilterValue: 'Small Cap',
    },
    {
      title: 'Contra funds',
      fundType: 'Equity',
      categoryFilterValue: 'Contra',
    },
    {
      title: 'Dividend yield funds',
      fundType: 'Equity',
      categoryFilterValue: 'Dividend yield',
    },
    {
      title: 'ELSS',
      fundType: 'ELSS',
      // categoryFilterValue:"Dividend yield",
    },
  ],
  // 'Equity','Flexi cap  funds','Large cap funds','Contra funds','Small cap funds','Dividend yield funds','ELSS funds','Sectoral funds','Mid cap funds','Value funds'
  fundsTable: {
    heading: [
      {
        title: 'FUND',
        className: 'large-2 small-3',
        textClass: 'lil-text-s-12',
      },
      {
        title: 'NAV',
        className: 'large-1 small-3 pl20 desktop-only sm:lil-hidden',
        textClass: 'lil-text-s-12',
      },
      {
        title: '5YR RETURN',
        className: 'large-1 small-3 pl20',
        textClass: 'lil-text-s-12',
      },
      {
        title: 'RISK',
        className: 'large-2 small-3 center desktop-only sm:lil-hidden',
        textClass: 'lil-text-s-12',
      },
      {
        title: 'EXIT LOAD',
        className: 'large-1 small-3 center desktop-only sm:lil-hidden',
        textClass: 'lil-text-s-12',
      },
      {
        title: 'COMPARE',
        className: 'large-1 small-3 center',
        textClass: 'lil-text-s-12',
      },
    ],
  },
  insights: [
    'Best ELSS (Tax-Saver) funds for you to investa in',
    'ELSS or Equity Linked Savings Schemes can save you upto ₹46,800 in taxes',
    'Get high returns on your investment along with great tax benefits',
    'Lock-in period of just 3 years - lowest among other 80C option',
    'Invest as low as ₹500 monthly in SIP and avoid last minute tax-saving hassle',
  ],
};

export const TOP_MUTUALFUNDS_STATIC = {
  Equity: [
    {
      title: 'Invest in mutual funds starting as low as ₹500',
    },
    {
      title:
        'We do the research for you and offer only the best equity funds in India',
    },
    {
      title:
        'Equity funds offer high returns at lower risk compared to stock market',
    },
    {
      title:
        'Suggested investment horizon of 5 years to reap the market-beating returns of these funds',
    },
    {
      title:
        'Equity funds invest in shares of companies based on market value. Invest in large, mid or small cap funds based on your preferences',
    },
  ],
  'Mid cap funds': [
    {
      title:
        'Diversified portfolio in medium-sized firms across sectors and industries',
    },
    {
      title:
        'Invests in mid-sized companies with higher chances of growth meaning potentially higher returns for investors.',
    },
    {
      title: 'Access to the next market leaders for inflation-beating returns.',
    },
    {
      title:
        'Cater to niche segments and expand their market share creating wealth for investors over time.',
    },
  ],
  'Large cap funds': [
    {
      title:
        'Diversified portfolio in large businesses to withstand market volatility',
    },
    {
      title:
        'Invests in well established firms with strong market position for stable returns',
    },
    { title: 'Steady wealth creation over time' },
    {
      title:
        'Invests in market leaders which have strong brand value and customer loyalty.',
    },
  ],
  'Small cap funds': [
    { title: 'Can outperform other market segments during a bull market' },
    {
      title:
        'Have the potential to become mid-cap and large-cap companies in the future',
    },
    { title: 'Diversified portfolio in small and emerging businesses' },
    {
      title:
        'Many focus on innovative business which could become the next market leaders',
    },
  ],
  'Contra funds': [
    {
      title:
        'Identifies hidden investment opportunities for higher returns in the long run',
    },
    { title: 'Potential to earn benchmark-beating returns in a bull market' },
    { title: 'Serves as a hedge against stock market correction' },
    {
      title: 'Opportunity to find the next market leaders',
    },
  ],
  'Dividend yield funds': [
    { title: 'Offers regular income through dividends' },
    { title: 'Lower impact from stock market downturn' },
    { title: 'Diversification across companies that pay regular dividends' },
    { title: 'Diversified portfolio in well established companies' },
  ],
  ELSS: [
    {
      title: 'Best ELSS (Tax-Saver) funds for you to invest in',
    },
    {
      title:
        'ELSS or Equity Linked Savings Schemes can save you upto ₹46,800 in taxes',
    },
    {
      title:
        'Get high returns on your investment along with great tax benefits',
    },
    {
      title: 'Lock-in period of just 3 years - lowest among other 80C options',
    },
    {
      title:
        'Invest as low as ₹500  monthly in SIP and avoid last minute tax-saving hassle',
    },
  ],
};
export const SECTION_STICKY_HEADER = [
  {
    title: 'Top funds',
    divIdentifier: 'fundsCategory',
  },
  {
    title: 'Top plans',
    divIdentifier: 'topPlans',
  },
  {
    title: 'Fund houses',
    divIdentifier: 'fundHouses',
  },
  {
    title: 'New fund offer',
    divIdentifier: 'nfo',
  },
  {
    title: 'Learn to invest',
    divIdentifier: 'learnMutualFunds',
  },
  // {
  //   title: 'New fund offer',
  //   divIdentifier: 'quickReads',
  // },
];
export const SECTION_TOP_PLANS = [
  {
    title: 'Save Taxes',
    return: '16.52%',
    lockInPeriod: '3 years',
    duration: '5 or more years',
    bgColor: '#dbf9e999',
    description:
      'Our Tax-Saver plan is a simple investment plan that’s safe, reliable and most rewarding among all 80C tax-saving instruments!',
    benefits: [
      'Invest any amount',
      'Reduce Tax upto ₹46,800',
      'Shortest lock-in: 3 Years',
      'Earn more than PPF, Tax FD',
    ],
    funds: [
      {
        title: 'Aditya Birla Sun Life Tax Relief 96',
        image: 'Birla.png',
        fundLink: '#',
      },
      {
        title: 'DSP Tax Saver Fund',
        image: 'DSP.png',
        fundLink: '#',
      },
      {
        title: 'Axis Long Term Equity Fund',
        image: 'Axis.png',
        fundLink: '#',
      },
      {
        title: 'ICICI Prudential Long Term Equity Fund',
        image: 'ICICI.png',
        fundLink: '#',
      },
    ],
    color: '#DBF9E9',
    id: '19',
  },
  {
    title: 'Aggressive Growth',
    return: '17%',
    lockInPeriod: 'No lock-in period',
    duration: '5 or more years',
    bgColor: '#d0e4fe99',
    description:
      'Double your invested money in almost 5 years with our exclusive aggressive Grow Wealth Plan',
    benefits: [
      'Just started working?',
      'Get into habit of investing',
      'Grow wealth for cost of beer and pizza over weekends',
    ],
    funds: [
      {
        title: 'L&T Midcap Fund - Direct Plan - Growth',
        image: '1599737950_landt_mf_v4.png',

        fundLink: '#',
      },
      {
        title: 'Kotak Small Cap Fund - Direct Plan - Growth',
        image: '1599738228_kotak_mf_v4.png',
        fundLink: '#',
      },
      {
        title: 'ICICI Prudential Value Discovery Fund - Direct Plan - Growth',
        image: 'ICICI.png',
        fundLink: '#',
      },
      {
        title: 'SBI Bluechip Fund',
        image: 'SBI.png',
        fundLink: '#',
      },
    ],
    color: '#D0E4FE',
    id: '26',
  },
  {
    title: 'Balanced Growth',
    return: '14.61%',
    lockInPeriod: 'No lock-in period',
    duration: '5 or more years',
    bgColor: '#fde4eccc',
    description:
      'Ideal investment choice for realizing Mid-size goals like Car, Vacations etc.',
    benefits: [
      'Buy a car or go on world tour',
      'Realise your short-term goals',
      'High returns at slightly higher risk.',
    ],
    funds: [
      {
        title: 'Mirae Asset Large Cap Fund - Direct Plan - Growth',
        image: '1599738147_miraeasset_mf_v4.png',
        fundLink: '#',
      },
      {
        title: 'DSP Midcap Fund - Regular Plan',
        image: 'DSP.png',
        fundLink: '#',
      },
      {
        title: 'Nippon India Corporate Bond Fund - Direct Plan - Growth',
        image: '1599736058_nippon_mf_v4.png',
        fundLink: '#',
      },
    ],
    color: '#FDE4EC',
    id: '25',
  },
  {
    title: 'Better than FD',
    return: '7.54%',
    lockInPeriod: 'No lock-in period',
    duration: '1 to 3 years',
    description:
      'Earn higher returns compared to any Bank FD’s or RD’s. Ideal for shorter 1-3 year investments',
    benefits: [
      'New to investing? Start here',
      'Growth and safety',
      'Higher returns than FD',
      'No Lock-in period',
    ],
    funds: [
      {
        title: 'Aditya Birla Sun Life Tax Relief 96',
        image: 'Birla.png',
        fundLink: '#',
      },
      {
        title: 'ICICI Prudential Long Term Equity Fund',
        image: 'ICICI.png',
        fundLink: '#',
      },
      {
        title: 'Nippon India Corporate Bond Fund - Direct Plan - Growth',
        image: '1599736058_nippon_mf_v4.png',
        fundLink: '#',
      },
      {
        title: 'SBI Bluechip Fund',
        image: 'SBI.png',
        fundLink: '#',
      },
    ],
    color: '#E7F7FF',
    id: '20',
  },
  {
    title: 'Quick Savings',
    return: '5.85%',
    lockInPeriod: 'No lock-in period',
    duration: '1 to 3 years',
    description:
      'Ideal choice to park your money, earning you higher returns compared to any other Savings bank account. Now, save money like a Pro!',
    benefits: [
      'Higher return on idle money',
      'Start with a small amount',
      'Withdraw money in 30 minutes',
      'No Exit Load, No Lock-in',
    ],
    funds: [
      {
        title: 'ICICI Prudential Long Term Equity Fund',
        image: 'ICICI.png',
        fundLink: '#',
      },
    ],
    color: '#E5E2FD',
    id: '21',
  },
  {
    title: 'Grow Rich',
    return: '16.1%',
    lockInPeriod: 'No lock-in period',
    duration: '1 to 3 years',
    description:
      'Reap rich rewards by investing in our exclusive Grow rich plan and fulfill all your long-term goals',
    benefits: [
      'High returns, balanced risk',
      'Expertly chosen funds',
      'Invest consistently to grow wealth',
    ],
    funds: [
      {
        title: 'ICICI Prudential Long Term Equity Fund',
        image: 'ICICI.png',
        fundLink: '#',
      },
      {
        title: 'SBI Bluechip Fund',
        image: 'SBI.png',
        fundLink: '#',
      },
    ],
    color: '#FEEADC',
    id: '22',
  },
];

export const SECTION_LEARN_MORE = {
  cards: [
    {
      title: 'Mutual fund basics',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651206_shortterm.png',
      link: 'https://cleartax.in/s/mutual-fund-investment/',
    },
    {
      title: 'Equity funds',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651232_equity.png',
      link: 'https://cleartax.in/s/equity-funds',
    },
    {
      title: 'Debt funds',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651287_incometaxreturns.png',
      link: 'https://cleartax.in/s/debt-funds',
    },
    {
      title: 'Hybrid funds',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651313_scales.png',
      link: 'https://cleartax.in/s/hybrid-funds',
    },
    {
      title: 'Investing & redeeming',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651363_maximumsaving.png',
      link: 'https://cleartax.in/s/mutual-fund-redemption',
    },
    {
      title: 'Analysing mutual funds',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651396_presentationchart.png',
      link: 'https://cleartax.in/s/mutual-fund-analysis',
    },
  ],
};

export const SECTION_QUICKREADS = [
  {
    title: 'Best Mutual Funds',
    description: `A mutual fund is formed when an asset management company (AMC) pools investments from several individual and institutional investors to purchase securities such as stocks and bonds.
      The AMCs have fund managers to manage the pooled investment. These are finance professionals with an excellent track record of managing a portfolio of investments. In short, mutual funds club investments from various investors to invest their money in bonds, stocks, and other similar avenues`,
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651911_frame18141168.png',
    link: 'https://cleartax.in/s/best-mutual-funds-india',
  },
  {
    title: 'SIP Mutual Funds',
    description:
      'Systematic Investment Plan, commonly referred to as an SIP, allows you to invest a small sum regularly in your preferred mutual fund scheme. By activating an SIP, a fixed amount is deducted from your bank account every month, which gets invested in the mutual fund of your choice.',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651937_frame18141167.png',
    link: 'https://cleartax.in/s/sip',
  },
  {
    title: 'How to Invest in mutual funds ?',
    description:
      'Mutual funds investment may seem complicated for first-time investors as it can be confusing at times. Understanding how mutual funds work is the first step in your investment .',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651967_onboarding.png',
    link: 'https://cleartax.in/s/never-invested-mutual-funds-heres-begin',
  },
  {
    title: 'How to save taxes with mutual funds?',
    description:
      'Types of Mutual Funds: Considering investing in Mutual Funds? Then it is of utmost importance to understand the various mutual fund types and the benefits they offer. Mutual fund types  ',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634651995_taxsaving.png',
    link: 'https://cleartax.in/s/best-tax-saving-mutual-funds',
  },
  {
    title: 'When to invest in mutual funds?',
    description:
      'The Goods and Services Tax is a unified, multi-stage, and consumption-based tax levied on the supply of goods or services, combining all stages such as supply of goods or services, .',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634652037_alarm.png',
    link: 'https://cleartax.in/s/mutual-fund-types',
  },
  {
    title: 'Debt Funds',
    description:
      'When companies or entities issuing debt instruments want to raise funds, they ‘borrow’ from investors. In return, they promise a steady and regular interest. This is how debt instruments work in simple terms.',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1634652102_maximumsaving.png',
    link: 'https://cleartax.in/s/debt-funds',
  },
];
export const SECTION_TESTIMONIALS = [
  {
    text: ' Great investing experience! Contacted the support with queries.. Got immediate response and all my doubts clarified. Will definitely recommend ClearTax to friends ',
    image:
      'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/nandita_saini.jpg',
    author: 'NANDITA SAINI',
    place: 'BANGALORE, KARNATAKA',
  },
  {
    text: ' I am new to investments and got all the information I need on your website. The suggestions for mutual fund investments and tax savings are great. ',
    image:
      'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/jyotsna_paul.jpg',
    author: 'JYOTSNA PAUL',
    place: 'BANGALORE, KARNATAKA',
  },
  {
    text: 'I have been using cleartax for investment from last 3 years ! Very effective and easy to use !',
    image:
      'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/manmohan.jpg',
    author: 'MANMOHAN MEHRA',
    place: 'BANGALORE, KARNATAKA',
  },
  {
    text: ' Investing through ClearTax is super easy and simple. It is extremely helpful for investors with less finance knowledge. ',
    image:
      'https://d2s63alnkuz6gf.cloudfront.net/assets/website/landing_page/testimonials/chethan.jpg',
    author: 'CHETHAN ELVIS DAS',
    place: 'CHENNAI, TAMILNADU',
  },
];

export const SECTION_TOOLS = [
  {
    title: 'Mutual fund calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231562_shortterm1.png',
    link: 'https://cleartax.in/s/mutual-fund-calculator',
  },
  {
    title: 'SIP calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231593_calendarcheck.png',
    link: 'https://cleartax.in/s/sip-calculator',
  },
  {
    title: 'PPF calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231598_ppf.png',
    link: 'https://cleartax.in/s/ppf-calculator',
  },
  {
    title: 'Tax saving calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231603_taxsaving.png',
    link: 'https://cleartax.in/s/tax-saving-calculator',
  },
  {
    title: 'FD calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231884_shield.png',
    link: 'https://cleartax.in/s/fd-calculator',
  },
  {
    title: 'Salary calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231899_briefcase.png',
    link: 'https://cleartax.in/s/salary-calculator',
  },
  {
    title: 'PF calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231908_pf.png',
    link: 'https://cleartax.in/s/pf-calculator',
  },
  {
    title: 'Income tax calculator',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1635231913_briefcase1.png',
    link: 'https://cleartax.in/s/tax-saving-calculator',
  },
];

export const EXPLORE_FUNDS = {
  bestHybridFunds: [
    {
      title: 'Multi Asset Allocation Mutual Funds',
      link: 'https://cleartax.in/s/multi-asset-allocation-fund',
    },
    {
      title: 'Dynamic Asset Allocation Mutual Funds',
      link: 'https://cleartax.in/s/best-dynamic-asset-allocation-mutual-funds',
    },
    {
      title: 'Best Arbitrage Funds',
      link: 'https://cleartax.in/s/best-arbitrage-funds',
    },
  ],

  mutualFundsType: [
    {
      title: 'ELSS Mutual Funds',
      link: 'https://cleartax.in/s/elss',
    },
    {
      title: 'SIP Mutual Funds ',
      link: 'https://cleartax.in/s/sip',
    },
    // {
    //   title: 'Mutual Fund Types ',
    //   link: 'https://cleartax.in/s/mutual-fund-types',
    // },
    {
      title: 'Hedge Funds',
      link: 'https://cleartax.in/s/hedge-funds',
    },
    {
      title: 'Debt Funds ',
      link: 'https://cleartax.in/s/debt-funds',
    },
    {
      title: 'Index Funds  ',
      link: 'https://cleartax.in/s/index-funds-etfs',
    },
    {
      title: 'Arbitrage Funds  ',
      link: 'https://cleartax.in/s/arbitrage-funds',
    },
    {
      title: 'Equity Funds',
      link: 'https://cleartax.in/s/equity-funds',
    },

    {
      title: 'Gilt Funds',
      link: 'https://cleartax.in/s/gilt-funds',
    },
    {
      title: 'Gold Funds ',
      link: 'https://cleartax.in/s/gold-funds',
    },
    {
      title: 'Pension Funds ',
      link: 'https://cleartax.in/s/pension-plans-india',
    },
    {
      title: 'Ultra Short Term Funds ',
      link: 'https://cleartax.in/s/ultra-short-term-mutual-funds',
    },
  ],

  bestDurationFunds: [
    {
      title: 'Best Low Duration Mutual Funds',
      link: 'https://cleartax.in/s/best-low-duration-mutual-funds',
    },
    {
      title: 'Index Funds India',
      link: 'https://cleartax.in/s/best-index-funds-india',
    },
    {
      title: 'Dynamic Bond Funds',
      link: 'https://cleartax.in/s/dynamic-bond-funds',
    },
    {
      title: 'Gilt Funds',
      link: 'https://cleartax.in/s/gilt-funds',
    },
    {
      title: 'Dividend Yield Mutual Funds',
      link: 'https://cleartax.in/s/dividend-mutual-funds',
    },
    {
      title: 'Contra Mutual Funds',
      link: 'https://cleartax.in/s/best-contra-mutual-funds',
    },
    {
      title: 'Value Funds',
      link: 'https://cleartax.in/s/best-value-funds',
    },
    {
      title: 'Arbitrage Funds',
      link: 'https://cleartax.in/s/arbitrage-funds',
    },

    {
      title: 'Credit Risk Funds',
      link: 'https://cleartax.in/s/best-credit-risk-funds',
    },
    {
      title: 'Sectoral Pharma Mutual Funds ',
      link: 'https://cleartax.in/s/best-sectoral-pharma-mutual-funds',
    },
    {
      title: 'Sectoral Banking Mutual Funds',
      link: 'https://cleartax.in/s/best-sectoral-banking-mutual-funds',
    },
    {
      title: '  Multi Asset Allocation Mutual Funds',
      link: 'https://cleartax.in/s/multi-asset-allocation-fund',
    },
    {
      title: 'Dynamic Asset Allocation Mutual Funds',
      link: 'https://cleartax.in/s/multi-asset-allocation-fund',
    },
    {
      title: 'Low Duration Mutual Funds',
      link: 'https://cleartax.in/s/best-low-duration-mutual-funds',
    },
    {
      title: 'Ultra Short Mutual Funds',
      link: 'https://cleartax.in/s/ultra-short-term-mutual-funds',
    },
  ],
  bestEquityFunds: [
    {
      title: ' Multi-cap funds',
      link: 'https://cleartax.in/s/invest-multi-cap-funds',
    },
    {
      title: 'Small-cap funds',
      link: 'https://cleartax.in/s/need-know-small-cap-equity-funds',
    },
    {
      title: 'Large-cap funds ',
      link: 'https://cleartax.in/s/large-cap-equity-funds-invest',
    },
    {
      title: 'Mid-cap funds',
      link: 'https://cleartax.in/s/mid-cap-equity-funds',
    },
    {
      title: 'ELSS funds',
      link: 'https://cleartax.in/s/elss',
    },
    {
      title: 'Index funds',
      link: 'https://cleartax.in/s/index-funds-etfs',
    },
    {
      title: 'Dividend yield funds',
      link: 'https://cleartax.in/s/dividend-mutual-funds',
    },
    {
      title: 'Sectoral pharma mutual funds',
      link: 'https://cleartax.in/s/best-sectoral-pharma-mutual-funds',
    },
  ],
  bestDebtFunds: [
    {
      title: ' Ultra Short Mutual Funds',
      link: 'https://cleartax.in/s/ultra-short-term-mutual-funds',
    },
    {
      title: 'Dynamic Bond Funds',
      link: 'https://cleartax.in/s/dynamic-bond-funds',
    },
    {
      title: 'Gilt Funds',
      link: 'https://cleartax.in/s/gilt-funds',
    },
    {
      title: 'Credit Risk Funds',
      link: 'https://cleartax.in/s/best-credit-risk-funds',
    },
    {
      title: 'Liquid Funds',
      link: 'https://cleartax.in/s/liquid-funds',
    },
  ],
};
export const FAQ_ITEMS = [
  {
    question: 'What Is A Mutual Fund And How Does It Work?',
    answer:
      'Mutual funds are one of the most popular investment options these days. A mutual fund is an investment vehicle formed when an asset management company (AMC) or fund house pools investments from several individuals and institutional investors with common investment objectives. A fund manager, who is a finance professional, manages the pooled investment. The fund manager purchases securities such as stocks and bonds that are in line with the investment mandate. Mutual funds are an excellent investment option for individual investors to get exposure to an expert-managed portfolio. Also, you can diversify your portfolio by investing in mutual funds as the asset allocation would cover several instruments. Investors would be allocated with fund units based on the amount they invest. Each investor would hence experience profits or losses that are directly proportional to the amount they invest. The main intention of the fund manager is to provide optimum returns to investors by investing in securities that are in sync with the fund’s objectives. The performance of mutual funds is dependent on the underlying assets.',
  },
  {
    question: 'How to choose a suitable mutual fund?',
    answer:
      'A right fund plan cannot be chosen only by considering the past performance of the fund and fund manager. To choose the right mutual fund, you need to check if the fund’s investment objective is in line with your goals.',
  },
  {
    question: 'How can you redeem your mutual fund units?',
    answer:
      'You can redeem MF units anytime. You need to inform your fund house or the agent. Your money will be deposited to your bank account within 3- 7 working days, post-redemption.',
  },
  {
    question: 'How to Save Taxes With Mutual Funds?',
    answer:
      'You can save up to Rs 46,800 a year in taxes by investing in equity-linked savings scheme (ELSS), the best tax-saving investment under Section 80C. The asset allocation of ELSS mutual funds is primarily made towards equity and equity-linked securities. ELSS mutual funds are the best tax-saving investment under Section 80C of the Income Tax Act, 1961. They come with a lock-in period of just three years, the shortest among all tax-saving investments. These mutual funds have the potential to provide returns in the range of 12% to 15%.ELSS funds are the only tax-saving investment with the potential to offer inflation-beating returns. Therefore, investing in ELSS mutual funds gives you the twin benefits of tax deductions and wealth creation over time.',
  },
  {
    question: 'What is CRISIL MF ranking?',
    answer:
      'CRISIL is an analytical company, which provides rankings, research, and advisory services. MF rankings given by CRISIL depend on global parameters. The rankings are very crucial for investors when they are deciding on a particular scheme.',
  },
  {
    question: 'Is SIP better than a lump sum?',
    answer:
      'It depends on the individuals and the market scenario. If you are risk-averse, then investing in via SIP is advisable. If the markets have fallen record levels, then a lump sum is advisable. Again, you need to assess your risk profile and requirements.',
  },
  {
    question: 'Do mutual funds invest only in stocks?',
    answer:
      'No, mutual funds don’t invest only in stocks. Only equity funds invest in stocks, while debt funds and liquid funds hardly invest in stocks. In fact, there are some debt funds that don’t invest in stocks at all.',
  },
  {
    question: 'What is an exit load?',
    answer:
      'It is the penalty charged by the fund house if you are not able to stay invested over a particular time frame. Most mutual funds are open-ended and come with no exit load. Investors should read the fund offer carefully before investing.',
  },
  {
    question: 'What is an expense ratio?',
    answer:
      'The expense ratio is the fee charged by the fund houses to manage the investments of the investors. It is always less than 2.5% of the amount invested by the investors.',
  },
  {
    question: 'Are mutual funds safe?',
    answer:
      'Yes, mutual fund investments are absolutely safe as all fund plans and fund houses are under the hawk eye of the Securities and Exchange Board of India (SEBI), the Association of Mutual Funds in India (AMFI), and the Reserve Bank of India (RBI).',
  },
  {
    question: 'Who can invest in mutual funds?',
    answer:
      'All individuals who have completed their KYC process are eligible to invest in mutual funds. However, some fund houses don’t accept investments from NRIs living in the United States and Canada due to the FACTA regulations.',
  },
  {
    question: 'Who Should Invest in Mutual Funds?',
    answer:
      'Everyone who has a particular financial goal, be it short-term or long-term, should consider investing in mutual funds. Investing in mutual funds is an excellent way to accomplish your goals faster. There are mutual fund plans that suit all personas. Investors need to assess their risk profile, investment horizon, and goals before getting started with their mutual fund investment. For example, if you are risk-averse and planning to purchase a car in five years, then you may consider investing in gilt funds. If you are ready to take some risk and are planning to buy a house in a period of fifteen to twenty years, then you may consider investing in equity funds. If your investment horizon is less than two years and you are looking to earn higher returns than a regular savings bank account, then you may consider parking your surplus funds in a liquid fund.',
  },
  {
    question: 'How much do I need to invest in mutual funds?',
    answer:
      'There is no fixed amount that you need to invest every year in a mutual fund. Most funds have a minimum investment of ₹1000, but the cumulative yearly investment can be as per your convenience. On ClearTax you can start investing with just ₹ 3000.',
  },
  {
    question: 'Which documents do I need for mutual fund investment KYC?',
    answer: `The documents required for KYC are:
      - 1 passport size photograph
      - 1 copy of PAN
      - 1 address proof
      With these documents, the entire KYC process can be done online when you invest through ClearTax.`,
  },
  {
    question: 'Do I need to get KYC done to invest in tax-saving mutual funds?',
    answer:
      'Yes. Know Your Customer (KYC) compliance is mandatory to invest in ELSS funds. But unlike you would think, KYC is not a difficult process. ClearTax has a completely paperless process for KYC which can be completed online.',
  },
  {
    question: 'Do ELSS mutual funds have additional benefits?',
    answer:
      'Tax-saving mutual funds come with the dual benefit of tax saving and wealth creation. They help you not only save taxes but build wealth over the long-term as well because these mutual funds invest primarily in equities and earn higher returns than traditional tax-saving investments like PPF, FDs and NSC.',
  },
  {
    question: 'How much does ClearTax charge when I invest in mutual funds?',
    answer:
      'ClearTax is completely free for you. We do not charge any commission from our users. We get a commission from funds that help us keep our service free and high quality.',
  },
  {
    question: 'Is it safe to invest in mutual funds via ClearTax?',
    answer:
      'ClearTax is registered with the Association of mutual funds (AMFI) under ARN code: ARN110027. Your investments made through ClearTax are 100% genuine. All data and transactions are protected with 128-bit encryption.',
  },
  {
    question:
      'Who gets the money that I invest in mutual funds through ClearTax?',
    answer:
      'Your money goes directly to the accounts of the mutual funds that you invest in. it does not come to ClearTax. At the time of redemption, the money will be transferred by the fund company and deposited directly to your bank account.',
  },
];

export const COMPONENT_MAP = [
  {
    component: GrowthSection,
    fnProps: ['openQRmodal'],
  },
  {
    component: StickyHeader,
    props: { SECTION_STICKY_HEADER },
    fnProps: ['insideView'],
    stateProps: ['plansActiveState'],
  },
  {
    component: TopFundsSection,
    observerId: 'fundsCategory',
    props: { SECTION_TOP_FUNDS },
    fnProps: ['searchFund'],
    stateProps: ['topFunds'],
  },
  {
    component: TopPlansSection,
    observerId: 'topPlans',
    props: { SECTION_TOP_PLANS },
  },
  {
    component: FundHousesSection,
    observerId: 'fundHouses',
    stateProps: ['otherAMCList'],
  },
  {
    component: NFOSection,
    observerId: 'nfo',
  },
  {
    component: LearnMutualFund,
    props: { SECTION_LEARN_MORE },
    observerId: 'learnMutualFunds',
  },
  {
    component: QuickReads,
    props: { SECTION_QUICKREADS },
  },
  {
    component: WhyCleartaxNew,
    identifier: 'WhyCleartaxNew',
    props: { Heading, title: 'Why Invest with ClearTax' },
  },
  // {
  //   component: TestimonialsSection,
  //   props: { SECTION_TESTIMONIALS },
  //   identifier: 'TestimonialsSection',
  // },

  {
    component: UsefullToolsSection,
    props: { SECTION_TOOLS },
  },
  {
    component: BlackBanner,
    fnProps: ['insideView'],
    stateProps: ['showQRModal'],
    // props:{SECTION_TESTIMONIALS},
    identifier: 'BlackBanner',
  },
  {
    component: ExploreFundSection,
    props: { EXPLORE_FUNDS },
  },
  {
    component: FaqSection,
    props: { FAQ_ITEMS },
  },
];



// WEBPACK FOOTER //
// ./constants/homeConstantsNew.ts